import { initialTimeFormat } from 'shared/types/date-format-options';
import { User } from 'shared/types/user';

export const getTimeFormat = (user?: User | null) =>
  user?.settings?.timeFormat ?? initialTimeFormat;
